module.exports = __webpack_public_path__ + "static/media/logout.750c262c.svg";